module.exports = __webpack_public_path__ + "static/media/floor_floating_climaComfort.ff38d90e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/floor_floating_climaComfort.png
 ** module id = 952
 ** module chunks = 0
 **/